export default "__VITE_ASSET__DnuityBT__"